module.exports = __webpack_public_path__ + "media/images/draps-83952e37ab4f5672655acf40bf67b78e.svg";